import React, { useContext } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import FlipCommandOption from './CommansOptions/FlipCommandOption';
import CropCommandOption from './CommansOptions/CropCommandOption';
import EditImageCommandOption from './CommansOptions/EditImageCommandOption';
import ReplaceImageCommandOption from './CommansOptions/ReplaceImageCommandOption';
import { Context } from "routes/private/Editor/Context";
import BorderComandOption from '../ShapeCommandBar/CommandsOptions/BorderCommandOption';

const ImageCommandBar:React.FC<IProps> = (props) => {
  let { editorStatus } = useContext(Context);

  return (
    <S.Root>
      { editorStatus.selectedElementsId.length===1 && 
        <>
          <CropCommandOption/>
          <S.Line/>
        </>
      }
      { !editorStatus.showCropImage && 
      <>
      <FlipCommandOption/>
      <S.Line/>
      </>
      }
      <BorderComandOption fromImage={true} />
      <S.Line/>
      { editorStatus.selectedElementsId.length===1 && 
        <>
          <EditImageCommandOption/>
          <S.Line/>
          <ReplaceImageCommandOption />
          <S.Line />
        </>
      }
    </S.Root>
  );
}

export default ImageCommandBar;